module.exports = __webpack_public_path__ + "static/Mock-92ab28d2e8143c2d37ad91c254fe936b.png";